import React from "react";


function Property() {
    return(
        <h1>Property </h1>
    )
}

export default Property;